import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { getRandomValueSamplingMethod } from "src/tenantCustomizations/tenants/demo1/spcSamplingMethods/randomValueSamplingMethod.tsx";
import { getCurrentTimeSamplingMethod } from "src/tenantCustomizations/tenants/dev/spcSamplingMethods/currentTimeSamplingMethod.tsx";
import { getStaticValueSamplingMethod } from "src/tenantCustomizations/tenants/dev/spcSamplingMethods/staticValueSamplingMethod.tsx";
import { getFailingSamplingMethod } from "src/tenantCustomizations/tenants/dev/spcSamplingMethods/failingSamplingMethod.tsx";
import { getCumulativeRecordSamplingMethod } from "src/components/views/spc/commonSamplingMethods/cumulativeRecordSamplingMethod.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";

export const devTenantCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			salesEnabled: true,
			crmEnabled: true,
			accountingIntegrationEnabled: true,
			customerOrderFreezingEnabled: true,
			reclamationsEnabled: true,
			configuratorEnabled: true,
			inputPricesWithVatByDefault: false,
			projectActivitySchedulingEnabled: true,
			surveysEnabled: true,
			winnerIntegrationEnabled: true,
			transportPlanningEnabled: true,
			deliveryPackageBundlingEnabled: true,
			reclamationRoundPlanningAiEnabled: true,
			projectActivityMaterialImportMethods: ["VERTEX", "SOLIDWORKS", "WINNER"],
			customerOfferLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			customerOrderLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			vectorEmbeddingsEnabled: true,
			jobQueueQrCodeEnabled: true,
			partCostOverridesEnabled: true,
			jobQueuePickingListEnabled: true,
			shopOrderTaskStatusInProductionPlanningEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		spc: {
			processImprovementsEnabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getRandomValueSamplingMethod(),
		getCurrentTimeSamplingMethod(),
		getStaticValueSamplingMethod(),
		getFailingSamplingMethod(),
		getCumulativeRecordSamplingMethod(),
	],
	erp: {
		production: {
			addShopOrdersToBatchView: {
				attributeFilterFields: [4, 6],
			},
		},
	},
} as const;
